import { render } from "./License.vue?vue&type=template&id=c3b7fec6&scoped=true"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"

import "./License.vue?vue&type=style&index=0&id=c3b7fec6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b7fec6"]])

export default __exports__